import React, { useCallback, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import speak from 'speaker';
import * as F from 'fetch';

import * as S from './styled';
import Select from './Select';
import Toggle from './Toggler';

const Header = ({ setBgImage, geoData, setIsSearch, setRegion, setIsCelsius, setTLocation, error }) => {
  const refInput = useRef(null);
  const submitBtn = useRef(null);

  const [isFetch, setIsFetch] = useState(false);
  const [speaker, setSpeaker] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    setSpeaker(speak(refInput, submitBtn));
  }, []);

  const currentError = (typeof error === 'boolean') ? t('error') : error;

  const handleRefresh = useCallback(async () => {
    if (isFetch) {
      return;
    }
    setIsFetch(true);
    await F.getBGImage(geoData, setBgImage);
    setIsFetch(false);
  }, [isFetch, geoData, setBgImage]);

  const submitHandler = (e) => {
    e.preventDefault();
    const {
      current: { value },
    } = refInput;
    setRegion(value);
    setIsSearch(true);
  };

  const speakHandler = () => {
    speaker.start();
  };

  return (
    <S.StyledHeader>
      <S.Container>
        <S.ButtonGroup>
          <S.RefreshButton type="button" onClick={handleRefresh} />
          <Select geoData={geoData} setTLocation={setTLocation} />
          <Toggle setIsCelsius={setIsCelsius} />
        </S.ButtonGroup>
        <S.ButtonGroup as="form" onSubmit={submitHandler}>
          <S.Input ref={refInput} type="search" name="search" placeholder={t('placeholder')} />
          <S.MicrophoneImg onClick={speakHandler} />
          <S.SearchButton ref={submitBtn} type="submit">
            {t('search')}
          </S.SearchButton>
          <S.Info error={error}>{currentError}</S.Info>
        </S.ButtonGroup>
      </S.Container>
    </S.StyledHeader>
  );
};

Header.defaultProps = {
  geoData: null,
  error: false,
};

Header.propTypes = {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  setBgImage: PropTypes.func.isRequired,
  setIsSearch: PropTypes.func.isRequired,
  setRegion: PropTypes.func.isRequired,
  setIsCelsius: PropTypes.func.isRequired,
  setTLocation: PropTypes.func.isRequired,
  geoData: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    DMS: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
    location: PropTypes.string,
    offsetSec: PropTypes.number,
  }),
};

export default Header;
